import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.style.transition = "opacity 0.5s ease-out"
      this.element.style.opacity = "0"
      this.element.addEventListener("transitionend", () => {
        this.element.remove()
      }, { once: true })
    }, 3000)
  }
}
